import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { IconTaxCard, IconTaxCard2 } from "../../common/icons";

export function PersonalTaxationInfo({ personalDashboardData }) {
  const { t, i18n } = useTranslation();

  const taxCardDate = personalDashboardData?.taxCardDate ?? "-";
  const taxCardPercent = personalDashboardData?.taxCardPercent ?? "-";
  const taxCardLimit = personalDashboardData?.taxCardLimit ?? "-";
  const taxCardPercentAdditional = personalDashboardData?.taxCardPercentAdditional ?? "-";

  let taxCardDateFormatted = "-";
  if (taxCardDate) {
    try {
      const dateObj = new Date(taxCardDate);
      taxCardDateFormatted = new Intl.DateTimeFormat(i18n.language, {
        year: "numeric",
        month: "numeric",
        day: "numeric",
      }).format(dateObj);
    } catch {
      taxCardDateFormatted = taxCardDate;
    }
  }

  return (
    <>
      <h4 style={{ color: "var(--heeros-blue)", marginBottom: "1rem" }}>
        {t("TaxCard", "Verokortti")}
      </h4>

      <Row className="tax-card-row gx-2 mb-2">
        <Col xs={6}>
          <div className="personalDashboardBlue3 d-flex align-items-center">
            <div className="tax-card-icon-wrapper">
              <IconTaxCard className="tax-card-icon" />
            </div>
            <div className="tax-card-text">
              <div className="tax-card-value">{taxCardPercent}%</div>
              <div className="tax-card-label">{t("TaxPercentage", "Veroprosentti")}</div>
            </div>
          </div>
        </Col>
        <Col xs={6}>
          <div className="personalDashboardBlue3 d-flex align-items-center">
            <div className="tax-card-icon-wrapper">
              <IconTaxCard className="tax-card-icon" />
            </div>
            <div className="tax-card-text">
              <div className="tax-card-value">{taxCardPercentAdditional}%</div>
              <div className="tax-card-label">{t("AdditionalPercentage", "Lisäprosentti")}</div>
            </div>
          </div>
        </Col>
      </Row>

      <Row className="tax-card-row gx-2">
        <Col xs={6}>
          <div className="personalDashboardBlue3 d-flex align-items-center">
            <div className="tax-card-text-alone">
              <div className="tax-card-value">{taxCardDateFormatted}</div>
              <div className="tax-card-label">{t("TaxCardValidFrom", "Voimassa alkaen")}</div>
            </div>
          </div>
        </Col>
        <Col xs={6}>
          <div className="personalDashboardRed3 d-flex align-items-center">
            <div className="tax-card-icon-wrapper">
              <IconTaxCard2 className="tax-card-icon" />
            </div>
            <div className="tax-card-text">
              <div className="tax-card-value">{taxCardLimit}€</div>
              <div className="tax-card-label">{t("IncomeLimit", "Tuloraja")}</div>
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
}
